import React from "react";

import TreeScreen from "./TreeScreen";

export default function NomenclaturesScreen(props) {
  return <TreeScreen {...props} treeRoot="nomenclatures" editable={true} />;
}
